import { CounterCustomerChargeEntity } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import _ from "lodash";
import { CounterCustomerChargeMaintenanceConstant } from "presentation/constant/CounterCustomerCharge/CounterCustomerChargeMaintenanceConstant";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const StuffingPanel = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const COUNTER_CUSTOMER_CHARGE_CONSTANT = CounterCustomerChargeMaintenanceConstant.Detail;
    const { editingEntity } = counterCustomerChargeState;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();

    const handleSaveClick = useCallback(async () => {
        if (_.isEmpty(counterCustomerChargeState.selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        if (counterCustomerChargeState.selectedRows.some(row => row.cntrStatus1 === "EM")) {
            messageBarVM.showError("EM Container, Can't do CFS Stuffing and Unstuffing");
            return;
        }
        setIsLoading(true);
        let entityList: CounterCustomerChargeEntity[] = [];
        counterCustomerChargeState.selectedRows.forEach(item => {
            if (editingEntity.cfsBy && editingEntity?.cfsBy === "CFS by Terminal") {
                item.cfsBy = "T";
            } else if (editingEntity.cfsBy && editingEntity?.cfsBy === "CFS by Customer") {
                item.cfsBy = "C";
            } else {
                item.cfsBy = editingEntity?.cfsBy;
            }
            entityList.push(item);
        });
        counterCustomerChargeVM.onStuffing(entityList).then(async (res) => {
            setIsLoading(false);
            if (res && res.success) {
                if (res.data) {
                    messageBarVM.showError(res.data);
                } else {
                    messageBarVM.showSuccess("CFS Stuffing & Unstuffing Successfully.");
                }
                counterCustomerChargeVM.onMoreClose();
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
            } else {
                messageBarVM.showError("CFS Stuffing & Unstuffing Falied.");
                counterCustomerChargeVM.onMoreClose();
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
            }
        });
    }, [counterCustomerChargeVM, counterCustomerChargeState.selectedRows, counterCustomerChargeState.searchCriteria, messageBarVM, editingEntity]);

    const handClose = useCallback(() => {
        counterCustomerChargeVM.onMoreClose();
    }, [counterCustomerChargeVM]);

    const adjTypeDropdownOptions = useMemo(() => {
        return [{
            dropdownLabel: "N/A",
            tagLabel: "N/A",
            value: "N/A",
        }, {
            dropdownLabel: "CFS by Customer",
            tagLabel: "CFS by Customer",
            value: "CFS by Customer",
        }, {
            dropdownLabel: "CFS by Terminal",
            tagLabel: "CFS by Terminal",
            value: "CFS by Terminal",
        }]
    }, []);

    const memoStuffing = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={editingEntity.cfsBy || ''}
                fieldValue={editingEntity.cfsBy}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.STUFFING_REQUEST}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cfsBy'}
                maxLength={60}
                options={adjTypeDropdownOptions}
                requiredFieldList={["cfsBy"]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onCounterCustomerFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COUNTER_CUSTOMER_CHARGE_CONSTANT.STUFFING_REQUEST, editingEntity?.cfsBy, adjTypeDropdownOptions, counterCustomerChargeVM])


    return (<div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <HeaderTitle>{"CFS Stuffing & Unstuffing"}</HeaderTitle>
                </Sidebarheader>
            </div>
        </div>

        {isLoading && <Loader Indicator="Spinner" size="Medium" />}

        <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    {memoStuffing}
                </div>
            </div>
        </div>
        <SidebarActionBar>
            <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={handClose} />
            <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />
        </SidebarActionBar>
    </div>)
}

export default memo(StuffingPanel);